// https://www.color-hex.com/
const colors = {
  FIRST: "#93C355", // green
  SECOND: "#E63036", // red
  THIRD: "#2A91C1", // blue
  FOURTH: "#F8E000", // yellow
  FIFTH: "#A74C97" // pink
};

export const cssColors = {
  FIRST: { css: "green", hex: "#54ae71" },
  SECOND: { css: "red", hex: "#e23b4d" },
  THIRD: { css: "blue", hex: "#1d5f82" },
  FOURTH: { css: "yellow", hex: "#fec917" },
  FIFTH: { css: "pink", hex: "#e13998" }
};

/*
additional colors:
{css: "orange", hex: "#f8823c"}
{css: "olive", hex: "#00a1cb"}
{css: "teal", hex: "#f8823c"}
{css: "violet", hex: "#525394"}
{css: "purple", hex: "#ad417f"}
{css: "brown", hex: "#a67a01"}
{css: "grey", hex: "#5a676d"}
{css: "black", hex: "#1a1b1d"}
*/

export default colors;
